export const ROOT_ID = 'root';
export const EVENT_GENERATED_STYLES_ID = 'events-generated-styles';
